module.exports = __webpack_public_path__ + "static/media/logo.821a69ca.png";